import { type MqttClient, MqttContext, type MqttContextType } from '@unifyapps/network/mqttClient';
import _noop from 'lodash/noop';
import { useContext } from 'react';
import useIsPrintPreview from '../../hooks/useIsPrintPreview';

const DUMMY_MQTT_CONTEXT: MqttContextType = {
  client: null,
  connectClient: () => {
    return Promise.resolve();
  },
  disconnectClient: () => {
    return Promise.resolve();
  },
  publish: _noop as MqttClient['publish'],
  subscribeToTopic: _noop,
  unsubscribeFromTopic: _noop,
};

export const useMqttClient = (params?: { returnDummyContext?: boolean }): MqttContextType => {
  const { returnDummyContext = false } = params ?? {};

  const mqttContext = useContext(MqttContext);
  const isPrintPreview = useIsPrintPreview();

  if (isPrintPreview) {
    return DUMMY_MQTT_CONTEXT;
  }

  if (!mqttContext && returnDummyContext) {
    return DUMMY_MQTT_CONTEXT;
  }

  if (!mqttContext) {
    throw new Error('useMqttClient must be used within a MqttProvider');
  }

  return mqttContext;
};
